var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.625C24.7487 30.625 30.625 24.7487 30.625 17.5C30.625 10.2513 24.7487 4.375 17.5 4.375C10.2513 4.375 4.375 10.2513 4.375 17.5C4.375 24.7487 10.2513 30.625 17.5 30.625Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4987 26.9788C17.9014 26.9788 18.2279 26.6524 18.2279 26.2497C18.2279 25.847 17.9014 25.5205 17.4987 25.5205C17.096 25.5205 16.7695 25.847 16.7695 26.2497C16.7695 26.6524 17.096 26.9788 17.4987 26.9788Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.333V22.0832C17.5 21.042 18.0206 20.0693 18.8869 19.4918L19.7604 18.9084C20.4109 18.4746 20.9443 17.8869 21.3132 17.1975C21.6821 16.5081 21.8751 15.7382 21.875 14.9563V14.583C21.875 13.4227 21.4141 12.3099 20.5936 11.4894C19.7731 10.6689 18.6603 10.208 17.5 10.208C16.3397 10.208 15.2269 10.6689 14.4064 11.4894C13.5859 12.3099 13.125 13.4227 13.125 14.583",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.8423174519d1dd441f86cb44895efa90.svg";
export { ForwardRef as ReactComponent };